import { render, staticRenderFns } from "./CreditNoteDisplayView.vue?vue&type=template&id=5c2b22ca"
import script from "./CreditNoteDisplayView.vue?vue&type=script&lang=js"
export * from "./CreditNoteDisplayView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports